import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Grid,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
// Icons
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useSelector } from "react-redux";

export default function RolePrioritySelectorFromEdit({
  color,
  roleName,
  updatedRoleListMain,
  setUpdatedRoleListMain,
}) {
  const [roleList, setRoleList] = useState([]);

  // Store
  const { roles } = useSelector((state) => state.role);

  // Use Effects
  useEffect(() => {
    roles.length > 0 && setRoleList([...roles]);
  }, [roles]);

  useEffect(() => {
    roleList.sort((a, b) => a.priority - b.priority);
  }, [roleList]);

  useEffect(() => {
    let updatedRoleList = [...roleList];
    setUpdatedRoleListMain(updatedRoleList);
  }, [roleList]);

  useEffect(() => {
    if (roleList.length > 0) {
      let picked = [];
      roleList.map((x, i) => {
        const p = (({ roleName, color, priority }) => ({
          roleName,
          color,
          priority,
        }))(roleList[i]);
        picked.push(p);
      });
      let updatedRoleList = [...picked];
      updatedRoleList.sort((a, b) => a.priority - b.priority);
      setUpdatedRoleListMain(updatedRoleList);
    }
  }, [color, roleList, roleName]);

  // Functions
  // Promotion
  const handleRolePromotion = (index, priority) => {
    let updatedRoleList = [...updatedRoleListMain];
    updatedRoleList[index].priority = priority - 1;
    updatedRoleList[index - 1].priority = priority;
    updatedRoleList.sort((a, b) => a.priority - b.priority);
    setUpdatedRoleListMain(updatedRoleList);
  };

  // Demotion
  const handleRoleDemotion = (index, priority) => {
    let updatedRoleList = [...updatedRoleListMain];

    updatedRoleList[index].priority = priority + 1;
    updatedRoleList[index + 1].priority = priority;
    updatedRoleList.sort((a, b) => a.priority - b.priority);

    setUpdatedRoleListMain(updatedRoleList);
  };
  return (
    <>
      <List>
        {updatedRoleListMain &&
          updatedRoleListMain.map((x, i) => (
            <Grid
              key={i}
              container
              spacing={0}
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item xs={2} sm={1}>
                <IconButton
                  size="small"
                  onClick={() => handleRolePromotion(i, x.priority)}
                >
                  {i !== 0 && x.roleName === roleName && (
                    <KeyboardArrowUpIcon color="primary" />
                  )}
                </IconButton>
              </Grid>
              <Grid
                item
                xs={8}
                sm={10}
                sx={{
                  borderLeft:
                    i !== 0 && x.roleName === roleName && ".8rem solid black ",
                  borderRight:
                    i !== 0 && x.roleName === roleName && ".8rem solid black ",
                }}
              >
                <ListItem disablePadding sx={{ my: 0.5 }} dense>
                  <ListItemButton
                    sx={{
                      background: x.color,
                      "&:hover": { background: x.color, cursor: "grab" },
                    }}
                  >
                    <ListItemText
                      primary={`${x.roleName} ${
                        (i !== updatedRoleListMain.length - 1 || roleName) &&
                        " | Priority: " + x.priority
                      }`}
                    />
                  </ListItemButton>
                </ListItem>
              </Grid>
              <Grid item xs={2} sm={1}>
                <IconButton
                  size="small"
                  onClick={() => handleRoleDemotion(i, x.priority)}
                >
                  {i !== updatedRoleListMain.length - 1 &&
                    x.roleName === roleName && (
                      <KeyboardArrowDownIcon color="error" />
                    )}
                </IconButton>
              </Grid>
            </Grid>
          ))}
      </List>
    </>
  );
}
